import { View } from 'ckeditor5/src/ui';
export default class IconView extends View {
    constructor(locale, icon) {
        super(locale);
        this.setTemplate({
            tag: 'i',
            attributes: {
                class: icon
            }
        });
    }
}
